import Link from 'next/link';

import { transformXOriginURL } from 'react-scale/lib/transformx';
import dato from 'react-scale/lib/dato/gql';

import Header from 'react-scale/components/pages/transformx/header';
import Footer from 'react-scale/components/ui/footer';
import PreFooter from 'react-scale/components/pages/transformx/pre-footer';
import Speaker from 'react-scale/components/pages/transformx/speaker';
import TransformxWrapper from 'react-scale/components/pages/transformx/common/transformx-wrapper';

const SpeakerProfile = ({ speaker, sessions }) => (
  <TransformxWrapper>
    <Header
      title="Scale TransformX Conference | Oct 19th - 21st"
      description="Join Scale AI for a two-day, virtual conference as we explore the shift from research to reality within AI and Machine Learning."
      canonical={`${transformXOriginURL}/events/transformx`}
      ogImg={
        speaker.ogImage?.url ?? `${transformXOriginURL}/static/images/pages/transformx-2022/og.jpg`
      }
      twImg={
        speaker.ogImage?.url ?? `${transformXOriginURL}/static/images/pages/transformx-2022/og.jpg`
      }
    />
    <div className="container mt-8 mb-16">
      <Link href="/events/transformx/speakers">
        <a className="hover:underline">
          <span>&larr;</span> Back to index
        </a>
      </Link>
      <Speaker speaker={speaker} sessions={sessions} />
    </div>
    <PreFooter />
    <Footer textColor="text-white" borderColor="border-tundora" border />
  </TransformxWrapper>
);

export const getStaticPaths = async () => {
  const { allEventTransformxSpeakers } = await dato().TransformXSpeakerSlugs();
  const paths = allEventTransformxSpeakers.map(speaker => ({
    params: { slug: speaker.slug.toString() }
  }));

  return { paths, fallback: 'blocking' };
};

export const getStaticProps = async ({ params }) => {
  const { eventTransformxSpeaker: speaker } = await dato().TransformXSpeaker({ slug: params.slug });
  const { allEventTransformXSessions: sessions } = speaker
    ? await dato().TransformXSpeakerSessions({ id: speaker.id })
    : [];

  if (!speaker) {
    return { notFound: true };
  }

  return {
    props: { speaker, sessions },
    revalidate: 1
  };
};

export default SpeakerProfile;
